import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import L from "leaflet";
import { ScaleControl, Circle, CircleMarker, MapContainer, MapConsumer, Marker, Popup, SVGOverlay, TileLayer } from "@monsonjeremy/react-leaflet";

import estrellaRoja from '../../img/estrella_roja.png';
import Contexto from "../comun/Contexto";
import { Link } from "react-router-dom";

const Mapa = ({datos, idCP})=> {
    /* Contexto */
    const { urlBaseRest, mapaIntensidadesURLCapaBase } = useContext(Contexto);

    /* Estado */    
    const [infoDetalleSismo, setInfoDetalleSismo] = useState(null);
    const[ubicacionCP, setUbicacionCP] = useState(null);

    const bounds = [
        [5.5, -72.8],
        [5.7, -73]
    ]

    /** Efectos */
    useEffect(async ()=>{
        let u = await _traerUbicacion(urlBaseRest+"ubicacion_centro_poblado/"+idCP);
        if (u != null)
            setUbicacionCP([u.SGEO_LATIT, u.SGEO_LONGIT]);
    }, [])
    

    /* Parametros */
    const centro = [5.6, -72.9]; 
    const zoomInicial = 5;
    
    const mapClick= (e)=> {        
        setInfoDetalleSismo(null);
    }

    const _traerUbicacion = async(url) => {	           
        if (!url) {
            return;
        }
        const res = await axios(url);
        return res.data;
    };        

    const initMapa =(map) => {	
        map.removeControl(map.attributionControl);
        map.on("click", mapClick)                   
        return null;
    }
        
    /* Render */   
    return (
        <Fragment>     
            
        <MapContainer center={centro} zoom={zoomInicial} scrollWheelZoom={true} style={{height:"100%", width:"100%"}}>            
        <ScaleControl position="bottomleft" />
            <TileLayer url={mapaIntensidadesURLCapaBase} />   
            <MapConsumer>
            { initMapa }
        </MapConsumer> 

        {ubicacionCP &&  <Marker position={ubicacionCP}/>}   

        {datos.map((d, index)=>{
            if (typeof (d.latitud) == "undefined") {                    
                return;
            }
            
            let lat = parseFloat(d.latitud);
            let lon = parseFloat(d.longitud);
                       
            return (
                <Estrella latlon={[lat, lon]} datos={d}                 
                setInfoDetalleSismo={setInfoDetalleSismo}/>
            )
        })}                
        </MapContainer>
        {infoDetalleSismo != null && <DetalleSismo infoDetalleSismo={infoDetalleSismo}/>}
        </Fragment>
    )
}

export default Mapa;

const DetalleSismo = ({infoDetalleSismo})=>{
    const enlace = "res_mapa/"+infoDetalleSismo.ID;
    return (
        <div>
            {infoDetalleSismo.fecha}, Magnitud: {infoDetalleSismo.magnitud} 
            <br/>Intensidad sitio: {infoDetalleSismo.I}
            <br/><Link to={enlace}>Ver sismo</Link>
        </div>
    );
}

const Estrella =({latlon, datos, setMostrarDetalleSismo, setInfoDetalleSismo})=> {
    let icono = L.icon({
        iconUrl: estrellaRoja,
        iconRetinaUrl: estrellaRoja,
        iconAnchor: null,
        popupAnchor: null,
        iconSize: [25, 25],
    });

    return (
        <Marker position={latlon} icon={icono} eventHandlers={{
            click: () => {                    
                setInfoDetalleSismo(datos)                
            },
        }}/>
    )
}